<template>
	<div class="view auth">
		<div class="auth__body">
			<RouterLink :to="{name:'calculator'}"><img src="@/assets/spro-logo.png" alt="Sentencing Pro" class="auth__logo" /></RouterLink>
			<RouterView name="Content" class="auth__content" />
		</div>
	</div>
</template>

<script>
import { useUserStore } from '@/lib/store/user'
import { useHead } from '@unhead/vue'

import Card from '@/components/Card.vue'

export default {
	name: 'ViewAuth',
	components: {
		Card,
	},
	setup() {
		useHead({
			script: [
				{
					src: `https://www.googletagmanager.com/gtag/js?id=${import.meta.env.VITE_GA_ID}`,
					async: true,
				},
				{
					innerHTML: `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments); }gtag('js', new Date()); gtag('config', '${import.meta.env.VITE_GA_ID}');`
				}
			]
		})

		return {
			userStore: useUserStore(),
		}
	},
	computed: {
		authStep() {
			return this.userStore.authStep
		},
	},
	watch: {
		authStep: {
			handler(newVal, oldVal) {
				// if (newVal == oldVal) return
				switch(newVal) {
					case 'verify':
						this.$nextTick()
							.then(
								this.$router.push({name: 'verify'})
							)
						break
					case 'select':
						this.$nextTick()
							.then(
								this.$router.push({name: 'select'})
							)
						break
					case 'complete':
						this.$nextTick()
							.then(() => {
								console.log('TOKEN', this.userStore.authToken, this.userStore.authData )
								this.userStore.signInCustom(this.userStore.authToken, this.userStore.authData?.tenantId)
									.then(res => {
										this.$router.push({name: 'calculator'})
									})
							})

				}
			},
			immediate: true,
		},
	},
}
</script>

<style scoped lang="scss">
.auth {
	display: grid;
	min-height: 100vh;
	place-items: center;

	background:
		linear-gradient(217deg, rgba(43, 167, 255, 0.622), rgba(255,0,0,0) 70.71%),
		linear-gradient(127deg, rgba(192, 201, 227, 0.4), rgba(0,255,0,0) 70.71%),
		linear-gradient(336deg, rgba(5, 52, 170, 0.509), rgba(0,0,255,0) 70.71%),
		linear-gradient(87deg, rgba(77, 205, 156, 0.209), rgba(0,0,255,0) 70.71%),
		#ffffff;

	&__body {
		display: grid;
		grid-template-columns: 1fr;
		place-items: center;
		max-width: 960px;
		width: 100%;

		:deep(.card) {
			background-color: rgba(255, 255, 255, 0.6);
			border: 0;
			border-radius: 1rem;
			box-shadow: inset 0 1px 1px 0 hsla(0,0%,100%,.1),0 50px 100px -20px rgba(50,50,93,.25),0 30px 60px -30px rgba(0,0,0,.3);
			width: 100%;

			&:after {
				display: none;
			}
		}
	}

	&__logo {
		max-width: 340px;
		margin-bottom: 1rem;
		width: calc(100% - 2rem);
	}
}
</style>
